module.exports = __webpack_public_path__ + "img/nt127-04-98.prt.2e94f70c.jpg";